import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PersonSimpleWithRole } from '@app/models/project.models';
import { LocalizedValue } from '@app/models/shared.models';
import { PersonRoleType } from '@app/models/shared.enums';
import { v4 as uuidv4 } from 'uuid';
import {
  EmailPositionFormData,
  EmailPositionFormGroup,
  getEmailPositionData,
  getEmailPositionFormGroup,
  getEmailPositionFormGroupFromPersonSimpleWithRole,
  getEmailPositionFormValueFromPersonSimpleWithRole,
  patchEmailPositionFormWithPersonSimpleWithRole,
} from '../../email-position-form/email-position-form.helper';
import {
  getTitleNameData,
  getTitleNameFormGroup,
  getTitleNameFormGroupFromPersonSimpleWithRole,
  getTitleNameFormValueFromPersonSimpleWithRole,
  patchTitleNameFormFromPersonSimpleWithRole,
  TitleNameFormData,
  TitleNameFormGroup,
} from '../../title-name-form/title-name-form.helper';

export interface PersonContactCardFormData {
  id: string;
  nameTitle: TitleNameFormData;
  emailPosition: EmailPositionFormData;
}
export interface PersonContactCardFormGroup {
  id: FormControl<string>;
  nameTitle: FormGroup<TitleNameFormGroup>;
  emailPosition: FormGroup<EmailPositionFormGroup>;
}

export function getPersonContactCardFormGroup(
  fb: FormBuilder,
  required: boolean = false,
  personRoleCode: PersonRoleType | null = null
): FormGroup<PersonContactCardFormGroup> {
  return fb.nonNullable.group({
    id: fb.nonNullable.control<string>(uuidv4()),
    nameTitle: getTitleNameFormGroup(fb, required, personRoleCode),
    emailPosition: getEmailPositionFormGroup(fb),
  });
}

export function getPersonCtontactCardData(
  formGroup: FormGroup<PersonContactCardFormGroup>
) {
  return {
    nameTitle: getTitleNameData(formGroup.controls.nameTitle),
    emailPosition: getEmailPositionData(formGroup.controls.emailPosition),
  };
}

//TODO simplify formGroup creation
export function getPersonContactCardFormGroupFromPersonSimpleWithRole(
  fb: FormBuilder,
  required: boolean = false,
  person: PersonSimpleWithRole,
  nameTitles?: readonly LocalizedValue[],
): FormGroup<PersonContactCardFormGroup> {
  return fb.nonNullable.group({
    id: fb.nonNullable.control<string>(uuidv4()),
    nameTitle: getTitleNameFormGroupFromPersonSimpleWithRole(
      fb,
      required,
      person,
      nameTitles,
    ),
    emailPosition: getEmailPositionFormGroupFromPersonSimpleWithRole(
      fb,
      person
    ),
  });
}

export function patchPersonContactCardWithPersonSimpleWithRole(
  formGroup: FormGroup<PersonContactCardFormGroup>,
  PersonSimpleWithRole: PersonSimpleWithRole,
  nameTitles?: readonly LocalizedValue[],
): void {
  formGroup.controls.id.setValue(uuidv4());
  patchTitleNameFormFromPersonSimpleWithRole(
    formGroup.controls.nameTitle,
    PersonSimpleWithRole,
    nameTitles,
  );
  patchEmailPositionFormWithPersonSimpleWithRole(
    formGroup.controls.emailPosition,
    PersonSimpleWithRole
  );
}

export function getPersonContactCardFormValueFromPersonSimpleWithRole(
  person: PersonSimpleWithRole | null,
  nameTitles?: readonly LocalizedValue[],
): PersonContactCardFormData {
  return {
    id: uuidv4(),
    nameTitle: getTitleNameFormValueFromPersonSimpleWithRole(
      person,
      nameTitles,
    ),
    emailPosition: getEmailPositionFormValueFromPersonSimpleWithRole(person),
  };
}
